import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {environment} from '../../../environments/environment';
import {StagingAuthService} from '../../shared/services/staging-auth.service';

export const canActivateStagingAuth: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const stagingAuthService = inject(StagingAuthService);
  const router = inject(Router);

  if (environment.requireStagingAuth && !stagingAuthService.isAuthenticated()) {
    return router.createUrlTree(['/staging-login'], {
      queryParams: {returnUrl: state.url},
    });
  }

  return true;
};
